import { transformSearch } from "@/api/helper.ts";
import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import countryService from "../services/country-service";

export const countrySearchQuery = z.object({
	search: z.string().optional(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
});

export const countriesQueryOptions = (search?: z.infer<typeof countrySearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["countries", search],
		queryFn: () => countryService.list(transformSearch(search, ["search"])),
		...options,
	});
};
